module.exports = __webpack_public_path__ + "static/media/6.02c9baa7.png";